import type { SessionEvent } from "./types"

export class EventBuffer {
  private events: SessionEvent[] = []
  private lastFlushAt = 0

  constructor(private cap = 500) {}

  push(event: SessionEvent): void {
    this.events.push(event)
    if (this.events.length > this.cap) {
      this.events = this.events.slice(-this.cap)
    }
  }

  get size(): number {
    return this.events.length
  }

  take(): SessionEvent[] {
    const out = this.events
    this.events = []
    return out
  }

  markFlushed(now: number = Date.now()): void {
    this.lastFlushAt = now
  }

  shouldFlush(now: number, maxAgeMs: number, maxSize: number): boolean {
    if (this.events.length === 0) return false
    if (this.events.length >= maxSize) return true
    return now - this.lastFlushAt >= maxAgeMs
  }
}
